import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import StepperLogin from "./StepperLogin";
import anim_auth from "../../assets/animations/anim_auth.json";
import Lottie from "lottie-web";
import { ShapesAuth } from "./ShapesAuth";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "../../app/slices/authSlice";
import { LoadingButton } from "@mui/lab";

const LoginForm = () => {
  const dispatch = useDispatch();
  const {
    auth: { loading },
  } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    Lottie.loadAnimation({
      container: document.querySelector("#auth-anim"),
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: anim_auth,
    });
  }, []);
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // function resend email
    // run function login
    const infoData = {
      email: data.get("email"),
      password: data.get("password"),
    };
    dispatch(Auth.login(infoData, navigate));
    // axios
    //   .post(`/auth/admin/login`, infoData)
    //   .then((res) => {
    //     console.log(res);
    //     toast.success(res.data?.message);
    //     Cookies.set("token", res?.data.token);
    //     axios.defaults.headers.common["Authorization"] =
    //       "Bearer " + Cookies.get("token");
    //     setUserInfoData(res.data?.data[0]);
    //     navigate("/");
    //   })
    //   .catch((err) => {
    //     toast.error(<div>{err.response?.data?.errors[0]}</div>);
    //   });
  };

  // // route if to hoe if user not login
  // useEffect(() => {
  //   if (userInfoData) {
  //     navigate("/");
  //   }
  // }, [userInfoData]);

  // hide and show password
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        background: "#ffffff44",
        backdropFilter: "blur(10px)",
      }}
    >
      <ShapesAuth />
      <Grid
        container
        sx={{
          maxWidth: { xs: "90vw", md: "70vw" },
          height: "70vh",
          my: "15vh",
          mx: "auto",
          justifyContent: "center",
          alignItems: "center",
          background: { xs: "#ffffff", lg: "#ffffff44" },
          padding: 0,
          boxShadow: "1px 4px 10px #dcdde1",
          borderRadius: "10px",
          overflow: "hidden",
          backdropFilter: "blur(20px)",
        }}
      >
        <CssBaseline />
        <Grid
          item
          md={false}
          lg={7}
          sx={{
            background: "#ffffff44",
            height: "100%",
            overflow: "hidden",
            display: { xs: "none", lg: "block" },
          }}
        >
          <Box sx={{ mt: "2vh" }}>
            <Box
              sx={{
                width: 360,
                height: 360,
                overflow: "hidden",
                mx: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span id="auth-anim"></span>
            </Box>
            <StepperLogin />
          </Box>
        </Grid>
        <Grid
          item
          md={12}
          lg={5}
          component={Paper}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "none",
            background: "#ffffff44",
          }}
        >
          <Box
            sx={{
              my: 4,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "none",
            }}
          >
            <Typography
              component="p"
              variant="p"
              fontWeight={500}
              sx={{
                mb: 1,
                background: "#a6263988",
                color: "#fff",
                borderRadius: 10,
                px: 1,
              }}
            >
              Admin
            </Typography>
            <Typography
              component="h1"
              variant="h3"
              fontWeight={500}
              sx={{
                mb: 3,
              }}
            >
              Sign in
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                id="password"
                autoComplete="current-password"
                type={showPassword ? "text" : "password"}
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Box sx={{ mt: 1, mb: 1, justifyContent: "center" }}>
                <Link to="/forgot-password" variant="body2">
                  Forgot password?
                </Link>
              </Box>
              <LoadingButton
                loading={loading}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
                style={{ padding: 12 }}
              >
                Sign In
              </LoadingButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginForm;
